{
    "Profile_SupernovaCommercial_LossPayees_LossPayee.lossPayeeDetails": "FR: Loss Payee details",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.businessName": "FR: Business Name",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.withRespectTo": "FR: With respect to (specify equipment, contents, CEF, etc.)",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.addressDetails": "FR: Address Details",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.locationDetails": "FR: Location Details"
}
